<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="添加员工奖励"
      width="800px"
      @close="closeDialog"
    >
      <el-form :model="detail" ref="form" :rules="rules" label-width="120px">
        <el-form-item label="员工id：" prop="userId">
          <el-input v-model="detail.userId"></el-input>
        </el-form-item>

        <el-form-item label="金额：" prop="amount">
          <el-input-number v-model="detail.amount" :min="1"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Editor from 'components/editor';
import Upload from 'components/upload';
import LANGUAGE from 'common/languages';

export default {
  name: 'kpiCreate',
  data() {
    return {
      dialogVisible: false,
      detail: {
        userId: '',
        coinType: 'FBS',
        amount: ''
      },
      options: [
        {
          value: '0',
          label: 'PC和APP'
        },
        {
          value: '1',
          label: 'PC'
        },
        {
          value: '2',
          label: 'APP'
        }
      ],
      types: [
        { value: '0', label: '普通抢购项目' },
        { value: '1', label: '新人专场' }
      ],
      rules: {
        userId: {
          required: true,
          message: '请填写'
        },
        coinType: {
          required: true,
          message: '请填写'
        },
        amount: {
          required: true,
          message: '请填写'
        }
      }
    };
  },
  components: {
    Editor,
    Upload
  },
  computed: {
    ...mapState('kpiProject', ['coinTypeList', 'languageList'])
  },
  methods: {
    ...mapActions('kpiProject', ['add']),
    closeDialog() {
      this.dialogVisible = false;
      this.detail = {
        distributionCoinType: 'FBS'
      };
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      this.add(this.detail).then(() => {
        this.$message({
          message: '添加成功！',
          type: 'success'
        });
        this.dialogVisible = false;
        this.$emit('refresh', {
          page: 1
        });
      });
    }
  }
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
